module.exports = __webpack_public_path__ + "img/GD_ACT.94271ad2.png";